import agencyCommissionApi from 'api/agencyCommissionApi';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// ---- thunks ----
// lay danh sach dai ly
export const thunkGetCommissionTransactionList = createAsyncThunk(
    'commissionTransaction/thunkGetCommissionTransactionList',
    async ({ params }, thunkAPI) => {
        const res = await agencyCommissionApi.getAgencyCommissionTransactions(params);
        return res;
    }
);

// ---- params ----
const initialState = {
    isGettingData: false,
    commissionTransactionList: [],
    total: 0,
};

const commissionTransactionSlice = createSlice({
    name: 'commissionTransaction',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(thunkGetCommissionTransactionList.pending, (state, action) => {
                state.isGettingData = true;
            })
            .addCase(thunkGetCommissionTransactionList.rejected, (state, action) => {
                state.isGettingData = false;
            })
            .addCase(thunkGetCommissionTransactionList.fulfilled, (state, action) => {
                state.isGettingData = false;
                const { result, transactions, total } = action.payload;
                if (result === 'success') {
                    state.commissionTransactionList = transactions ?? [];
                    state.total = total ?? 0;
                }
            });
    },
});

const { reducer, actions } = commissionTransactionSlice;
export const { } = actions;
export default reducer;
